// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-list/patients-list.less
// module id = 3828
// module chunks = 0